// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { satisfies } from 'semver';
import Vue from 'vue';
import Vuex from 'vuex';
import VueToast from 'vue-toast-notification';
import Vuelidate from 'vuelidate';
import { Datetime } from 'vue-datetime';
import VueCountryCode from "vue-country-code";

// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import App from './App';
import router from './router';

Vue.use(Vuex);
Vue.use(Datetime);
Vue.use(VueCountryCode);
Vue.use(Vuelidate);
Vue.use(VueToast, {
  position: "top-right"
});

Vue.config.productionTip = false;

const store = new Vuex.Store({
  state: {
    totalPricing: 0,
    maxPackageLimit: 4600,
    selectedPackage: null,
    selectedPackageInfo: {},
    packages: {
      names: [{
        displayName: "Basic",
        key: "basic"
      }, {
        displayName: "Standard",
        key: "standard"
      }, {
        displayName: "Premium",
        key: "premium"
      }],
      images: {
        commission: 0.25,
        cardCommission: 0.035,
        basic: {
          base: 499,
          hosted_48_hours: 999,
          hosted_offenders: 999,
          base_images_limit: 3,
          sub_domains: 999,
          valid_days: 21,
          additional_images: 175,
          additional_min_images: 0,
          additional_max_images: 23,
        },
        standard: {
          base: 999,
          hosted_48_hours: 999,
          hosted_offenders: 999,
          base_images_limit: 6,
          sub_domains: 999,
          valid_days: 14,
          additional_images: 175,
          additional_min_images: 0,
          additional_max_images: 20,
        },
        premium: {
          base: 1599,
          hosted_48_hours: 999,
          hosted_offenders: 999,
          sub_domains: 999,
          valid_days: 7,
          base_images_limit: 10,
          additional_images: 175,
          additional_min_images: 0,
          additional_max_images: 16,
        }
      },
      audio: {
        commission: 0.25,
        cardCommission: 0.035,
        basic: {
          base: 499,
          hosted_48_hours: 999,
          hosted_offenders: 999,
          base_images_limit: 3,
          sub_domains: 999,
          valid_days: 21,
          additional_images: 175,
          additional_min_images: 0,
          additional_max_images: 28,
        },
        standard: {
          base: 999,
          hosted_48_hours: 999,
          hosted_offenders: 999,
          base_images_limit: 6,
          sub_domains: 999,
          valid_days: 14,
          additional_images: 175,
          additional_min_images: 0,
          additional_max_images: 25,
        },
        premium: {
          base: 1599,
          hosted_48_hours: 999,
          hosted_offenders: 999,
          sub_domains: 999,
          valid_days: 7,
          base_images_limit: 10,
          additional_images: 175,
          additional_min_images: 0,
          additional_max_images: 21,
        }
      },
      word: {
        commission: 0.25,
        cardCommission: 0.035,
        basic: {
          base: 499,
          hosted_48_hours: 999,
          hosted_offenders: 999,
          base_images_limit: 3,
          sub_domains: 999,
          valid_days: 21,
          additional_images: 175,
          additional_min_images: 0,
          additional_max_images: 28,
        },
        standard: {
          base: 999,
          hosted_48_hours: 999,
          hosted_offenders: 999,
          base_images_limit: 6,
          sub_domains: 999,
          valid_days: 14,
          additional_images: 175,
          additional_min_images: 0,
          additional_max_images: 25,
        },
        premium: {
          base: 1599,
          hosted_48_hours: 999,
          hosted_offenders: 999,
          sub_domains: 999,
          valid_days: 7,
          base_images_limit: 10,
          additional_images: 175,
          additional_min_images: 0,
          additional_max_images: 21,
        }
      },
      video: {
        commission: 0.25,
        cardCommission: 0.035,
        basic: {
          base: 599,
          hosted_48_hours: 999,
          hosted_offenders: 999,
          sub_domains: 999,
          valid_days: 21,
          base_images_limit: 1,
          additional_videos: 399,
          additional_min_videos: 0,
          additional_max_videos: 10,
        },
        standard: {
          base: 1299,
          hosted_48_hours: 999,
          hosted_offenders: 999,
          sub_domains: 999,
          valid_days: 14,
          additional_videos: 399,
          base_images_limit: 3,
          additional_min_videos: 0,
          additional_max_videos: 8,
        },
        premium: {
          base: 2699,
          hosted_48_hours: 999,
          hosted_offenders: 999,
          sub_domains: 999,
          valid_days: 7,
          additional_videos: 399,
          base_images_limit: 7,
          additional_min_videos: 0,
          additional_max_videos: 4,
        }
      }
    },
    form_refId: "",
    form_packageSelection: "",
    form_firstName: "",
    form_lastName: "",
    form_country: "",
    form_email: "",
    form_mobileNumber: "",
    form_city: "",
    form_addressLine1: "",
    form_addressLine2: "",
    form_state: "",
    form_zipCode: "",
  },
  mutations: {
    selectedPackage (state, payload) {
      state.selectedPackageInfo = payload;
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store: store,
});



// WEBPACK FOOTER //
// ./src/main.js